import { React, PropTypes, APIPropTypes } from 'imports';
import { RequestStatus } from 'utils/constants';
import { FormattedResource, Popup, Spinner, Tooltip, Checkbox } from '../index';
import { addEvent, removeEvent, debounce } from 'utils';
import './PasswordInput.less';


class PasswordInput extends React.Component {

    static get propTypes() {
        return {
            value: PropTypes.string,
            confirmationValue: PropTypes.string,
            showConfirmInput: PropTypes.bool,
            onChange: PropTypes.func,
            onConfirmationChange: PropTypes.func,
            onValidate: PropTypes.func,
            validationTimeout: PropTypes.number,
            changeDebounceTimeout: PropTypes.number,
            isError: PropTypes.bool,
            errorMessage: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.element
            ]),
            passwordLabel: FormattedResource.resourcePropType,
            passwordConfirmationLabel: FormattedResource.resourcePropType,
            hint: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.element
            ]),
            disabled: PropTypes.bool
        };
    }

    static get defaultProps() {
        return {
            validationTimeout: 1500,
            changeDebounceTimeout: 300,
            showConfirmInput: false,
            passwordLabel: { id: 'welcome_guide.password' },
            passwordConfirmationLabel: { id: 'welcome_guide.confirm_password' },
            value: '',
            disabled: false
        };
    }

    valueValidationTimeoutID = null;

    confirmationValidationTimeoutID = null;

    valueChangeTimeoutID = null;

    confirmationValueChangeTimeoutID = null;

    constructor(props) {
        super(props);

        this.state = {
            isConfirmationValueChanged: false,
            isConfirmValueMatch: true,
            showPassword: false,
            value: props.value,
            confirmationValue: props.confirmationValue
        };
    }

    componentWillMount() {
        this.setState({
            value: this.props.value,
            confirmationValue: this.props.confirmationValue
        });
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.state.value && !this.valueChangeTimeoutID) {
            this.setState({ value: nextProps.value });
        }
        if (nextProps.confirmationValue !== this.state.confirmationValue && !this.confirmationValueChangeTimeoutID) {
            this.setState({
                confirmationValue: nextProps.confirmationValue
            });
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.props.isError !== nextProps.isError ||
            this.props.errorMessage !== nextProps.errorMessage ||
            this.props.hint !== nextProps.hint ||
            this.props.disabled !== nextProps.disabled ||
            this.state.showPassword !== nextState.showPassword ||
            this.state.isConfirmationValueChanged !== nextState.isConfirmationValueChanged ||
            this.state.isConfirmValueMatch !== nextState.isConfirmValueMatch ||
            this.state.value !== nextState.value ||
            this.state.confirmationValue !== nextState.confirmationValue
        );
    }

    _onValueChange = (e) => {
        let value = e.target.value;
        this.setState({
            value: value
        });

        if (this.valueChangeTimeoutID) {
            clearTimeout(this.valueChangeTimeoutID);
        }
        this.valueChangeTimeoutID = setTimeout(() => {
            this.props.onChange(this, value);
        }, this.props.changeDebounceTimeout);

        this._validateValue();

        this._validateConfirmationValue();
    }

    _onConfirmationValueChange = (e) => {
        let value = e.target.value;
        this.setState({
            isConfirmationValueChanged: true,
            confirmationValue: value
        });

        if (this.confirmationValueChangeTimeoutID) {
            clearTimeout(this.confirmationValueChangeTimeoutID);
        }
        if (this.props.onConfirmationChange) {
            this.confirmationValueChangeTimeoutID = setTimeout(() => {
                this.props.onConfirmationChange(this, value);
            }, this.props.changeDebounceTimeout);
        }
        this._validateConfirmationValue();
    }

    _validateValue = () => {
        if (this.valueValidationTimeoutID) {
            clearTimeout(this.valueValidationTimeoutID);
        }
        if (this.props.onValidate) {
            this.valueValidationTimeoutID = setTimeout(() => {
                this.props.onValidate(this.props.value);
            }, this.props.validationTimeout);
        }
    }

    _validateConfirmationValue = () => {
        if (this.confirmationValidationTimeoutID) {
            clearTimeout(this.confirmationValidationTimeoutID);
        }

        if (this.state.isConfirmationValueChanged && this.props.showConfirmInput) {
            this.confirmationValidationTimeoutID = setTimeout(() => {
                this.setState({
                    isConfirmValueMatch: this.props.value === this.props.confirmationValue
                });
            }, this.props.validationTimeout);
        }
    }

    _onShowPasswordChange = (sender, value) => {
        this.setState({ showPassword: value });
    }

    render() {
        return <div className="password-input">
            <div className="input-group">
                {
                    this.props.hint ?
                        <div className="hint">
                            {this.props.hint}
                        </div> :
                        null
                }
                <div className="label">
                    <FormattedResource resource={this.props.passwordLabel} />
                </div>
                <input className={'password-input' + (this.props.isError ? ' error' : '') + (this.props.disabled ? ' disabled' : '')}
                    disabled={this.props.disabled}
                    type={this.state.showPassword ? 'text' : 'password'}
                    value={this.state.value}
                    onChange={this._onValueChange}
                />
                <Checkbox value={this.state.showPassword} onChange={this._onShowPasswordChange}>
                    <FormattedResource resource={{ id: 'common.show_password' }} />
                </Checkbox>
            </div>
            {
                this.props.showConfirmInput ?
                    <div className="input-group">
                        <div className="label">
                            <FormattedResource resource={this.props.passwordConfirmationLabel} />
                        </div>
                        <input className={'password-input' + (this.state.isConfirmValueMatch ? '' : ' error') + (this.props.disabled ? ' disabled' : '')}
                            disabled={this.props.disabled}
                            type={this.state.showPassword ? 'text' : 'password'}
                            value={this.state.confirmationValue}
                            onChange={this._onConfirmationValueChange}
                        />
                        {
                            !this.state.isConfirmValueMatch ?
                                <div className="error-hint"><FormattedResource resource={{ id: 'common.passwords_dont_match' }} /></div> :
                                null
                        }
                    </div> :
                    null
            }
        </div>;
    }
}

export default PasswordInput;